import { useAuth } from './useAuth';

export type UserRole = 'admin' | 'astrologer' | 'user';

export function useUserRole(): UserRole {
  const { profile } = useAuth();
  if (profile?.is_admin) return 'admin';
  if (profile?.subscription_tier === 'astrologer_pro') return 'astrologer';
  return 'user';
}
